import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";

/**
 * Botão Cancelar padronizado (ícone X + Spinner ao carregar).
 * Uso em modais e formulários.
 *
 * @param {Function} onClick - Handler ao clicar
 * @param {boolean} [loading=false] - Se true, mostra Spinner e desabilita
 * @param {boolean} [disabled=false] - Desabilita o botão
 * @param {string} [variant='light'] - variant do Button (light, danger, outline-secondary, etc.)
 * @param {string} [className='modal-footer-btn-cancelar'] - Classes CSS adicionais
 * @param {string} [title='Cancelar'] - title para acessibilidade
 * @param {number} [iconSize=18] - Tamanho do ícone em px
 */
function Cancelar({
  onClick,
  loading = false,
  disabled = false,
  variant = "light",
  className = "modal-footer-btn-cancelar",
  title = "Cancelar",
  iconSize = 18,
  ...rest
}) {
  return (
    <Button
      variant={variant}
      className={className}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      {...rest}
    >
      {loading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <FaTimes size={iconSize} />
      )}
    </Button>
  );
}

export default Cancelar;
